import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteArticleDetails } from "../api/deleteArticleDetails";
import { DeleteArticleDetailsParams } from "../types";
import { articleGroupListQueryKey } from "./useArticleGroupListQuery";

export const useDeleteArticleMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: DeleteArticleDetailsParams) =>
      deleteArticleDetails(params),
    onMutate: async (params) => {
      await queryClient.cancelQueries({
        queryKey: articleGroupListQueryKey({
          brandId: params.brandId,
          categoryId: params.categoryId,
          groupId: params.groupId,
        }),
      });

      const previousArticles = queryClient.getQueryData(
        articleGroupListQueryKey({
          brandId: params.brandId,
          categoryId: params.categoryId,
          groupId: params.groupId,
        }),
      );

      queryClient.setQueryData(
        articleGroupListQueryKey({
          brandId: params.brandId,
          categoryId: params.categoryId,
          groupId: params.groupId,
        }),
        (old: any) =>
          old.filter((article: any) => article.id !== params.articleId),
      );

      return { previousArticles };
    },
    onError: (err, variables, context) => {
      if (context?.previousArticles) {
        queryClient.setQueryData(
          articleGroupListQueryKey({
            brandId: variables.brandId,
            categoryId: variables.categoryId,
            groupId: variables.groupId,
          }),
          context.previousArticles,
        );
      }
    },
  });
};
